import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ServiceGrid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ServicesPage.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ServicesCTA.module.css");
